import {useSelector} from "react-redux";
import {BREAK_SIDE_MENU, COLLAPSE_SIDE_MENU} from "../actions/types";

const INITIAL_STATE = {
    collapsed: localStorage.getItem("collapsedMenu") === 'true',
    sideMenuBroken: false
};

export default function sideMenuReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case COLLAPSE_SIDE_MENU: return {
            ...state,
            collapsed: action.payload
        };
        case BREAK_SIDE_MENU: return {
            ...state,
            sideMenuBroken: action.payload
        };
        default:
            return state;
    }
}

export const useSideMenuSelector = () =>
    useSelector(sideMenuSelector());

export const sideMenuSelector = () => state => state.sideMenu;